import type { AssignmentMap } from "../SettingsPayload";

import { selectAssignmentsForSlide } from "./selectAssignmentsForSlide";

/** 一覧を組むのに要る枚の情報。走査結果からそのまま渡せる形にしておく。 */
export type SlideOfDeck = {
    uid: string;
    elementUids: readonly string[];
};

/**
 * どの枚の一覧にも現れない生成担当の id を、`assignments` の並び順で返す。
 *
 * 画面Aと画面Bの担当一覧は枚を起点に組み立てるため、どの枚にも属さない担当は行き場が無く、
 * 開く導線も削除する手段も無くなる。本文に対象を書かないまま離れた担当や、対象にしていた
 * 図形がファイルから消えた担当がこれに当たる。ここで拾って画面Aへ出し、編集と削除の入口を
 * 作る（対象が無い担当は生成時に「対象がないため実行されません」となるので、実行前に気付ける
 * 利点もある）。
 */
export function selectUnboundAssignments(
    assignments: AssignmentMap,
    slides: readonly SlideOfDeck[]
): string[] {
    const bound = new Set<string>();
    for (const slide of slides) {
        for (const id of selectAssignmentsForSlide(assignments, slide.uid, slide.elementUids)) {
            bound.add(id);
        }
    }
    return Object.keys(assignments).filter((id) => !bound.has(id));
}
